import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
  count: 0,
  loading: false,
  searchTerm: "",
  roles: [],
  limit: [],
  currentRole: "ALL",
  isInput: false,
  selectedUser: null,
  selectedOption: "",
  selectOptionId: "ALL",
  rowsPerPage: "10",
  rowId: "PO002",
  error: null,
  adminUserData: {},
  languages: [],
  notifsAndPrefs: [],
};

const userSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    fetchUsers: (state, action) => {
      state.loading = true;
    },

    fetchUsersSuccess: (state, action) => {
      state.users = action.payload;
      state.loading = false;
    },
    fetchUsersFailure: (state, action) => {
      state.loading = false;
    },
    setUsers: (state, action) => {
      let data = action.payload.data;

      if (action.payload?.searchTerm) {
        state.searchTerm = action.payload.searchTerm;
        // state.count = action.payload.count;
      } else if (action.payload?.change) {
        state.users.push(...data);
        state.users = data;
        state.count = action.payload.count;
      } else {
        if (action.payload.change !== null) {
          state.users = data;
          state.count = action.payload.count;
        }
      }
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setRowId: (state, action) => {
      state.rowId = action.payload;
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    setSelectOptionId: (state, action) => {
      state.selectOptionId = action.payload;
    },
    resetAll: (state, action) => {
      state.users = [];
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    resetSearchTerm: (state, action) => {
      state.searchTerm = "";
    },
    setRoleStart: (state) => {
      state.loading = true;
    },
    setRoleSuccess: (state, action) => {
      state.roles = action.payload;
      state.loading = false;
    },
    setRoleFailure: (state, action) => {
      state.loading = false;
    },
    limitStart: (state, action) => {
      state.loading = true;
    },
    limitSuccess: (state, action) => {
      state.limit = action.payload;
      state.loading = false;
    },
    limitFailure: (state, action) => {
      state.loading = false;
    },
    addUserRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    addUserSuccess: (state, action) => {
      state.loading = false;
      state.users.push(action.payload);
    },
    addUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getAdminUserDetails: () => {},
    getNotificationTypes: () => {},
    setLanguages: (state, action) => {
      state.languages = action.payload;
    },
    setAdminUserDetails: (state, action) => {
      state.adminUserData = { ...action.payload["0"] };
    },
    setNotifsAndPrefs: (state, action) => {
      state.notifsAndPrefs = [...action.payload];
    },
    setAdminUserData: (state) => {
      state.loading = true;
    },
    resetLoading:(state)=>{
      state.loading = false;
    },
    removeAdminUser:(state)=>{
      state.loading = true;
    },

    reactivateUser:(state)=>{
      state.loading = true;
    },

    importAdminUsers:(state)=>{
      state.loading = true;
    }
  },
});

export const {
  fetchUsers,
  fetchUsersSuccess,
  fetchUsersFailure,
  setUsers,
  resetAll,
  resetSearchTerm,
  setRoleSuccess,
  setRoleFailure,
  setRoleStart,
  limitStart,
  limitSuccess,
  limitFailure,
  setRowsPerPage,
  setRowId,
  setSearchTerm,
  setSelectedOption,
  setSelectOptionId,
  addUserSuccess,
  addUserRequest,
  addUserFailure,
  getAdminUserDetails,
  setAdminUserDetails,
  setLanguages,
  getNotificationTypes,
  setNotifsAndPrefs,
  setAdminUserData,
  resetLoading,
  removeAdminUser,
  reactivateUser,
  importAdminUsers,
} = userSlice.actions;

export default userSlice.reducer;
